export enum NumericAlertKinds {
  Color = 1,
  Range = 2,
}
